import { Link } from 'react-router-dom';
import type { HotItem } from '@/types/content';
import TrendBadge from '@/components/feature/TrendBadge';

interface ArticleCardProps {
  item: HotItem;
  size?: 'default' | 'large';
}

export default function ArticleCard({ item, size = 'default' }: ArticleCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-card border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link to={`/article/${item.id}`} className="block">
        <div className={`relative w-full overflow-hidden ${size === 'large' ? 'h-56 md:h-72' : 'h-44'}`}>
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 瓜圈速报`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-foreground-950/80 px-2.5 py-1 text-[11px] font-medium text-background-50 backdrop-blur">
            {item.category}
          </span>
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/article/${item.id}`}>
          <h3
            className={`text-balance font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 ${
              size === 'large' ? 'text-lg md:text-xl' : 'text-[15px]'
            }`}
          >
            {item.title}
          </h3>
        </Link>
        <p className="mt-2.5 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-fire-line text-primary-500" />
              {item.heat}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-chat-3-line" />
              {item.comments}
            </span>
          </div>
          <TrendBadge trend={item.trend} value={item.trendValue} compact />
        </div>
      </div>
    </article>
  );
}